import {
  getOrder,
  getOrderDetails,
  getOrders,
  getOrdersReportNew,
  getOrdersReportTrip,
  getOrdersReportTripTracking
} from './thunk';

export const builderGetOrderDetails = (builder: any) => {
  builder.addCase(getOrderDetails.fulfilled, (state: any, action: any) => {
    state.orderDetails = action.payload;
    state.gettingOrderDetails = false;
    if (!state.orderDetailsList.find((item: any) => item.id === action.payload.id)) {
      state.orderDetailsList = [
        ...state.orderDetailsList,
        {...action.payload.data, id: action.payload.orderId}
      ];
    }
    state.getOrderDetailsError = '';
  });
  builder.addCase(getOrderDetails.pending, (state: any) => {
    state.gettingOrderDetails = true;
    state.getOrderDetailsError = '';
  });
  builder.addCase(getOrderDetails.rejected, (state: any) => {
    state.gettingOrderDetails = false;
    state.getOrderDetailsError = 'خطا در دریافت اطلاعات سفارش';
  });
};

export const builderGetOrders = (builder: any) => {
  builder
    .addCase(getOrders.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getOrders.fulfilled, (state: any, action: any) => {
      let temp: any = {};
      if (action.payload.data?.orders) {
        if (
          state.orders &&
          state.orders?.orders?.length &&
          state.orders.pagination.page !== action.payload.data.pagination.page
        ) {
          temp = state.orders;
          temp.orders.push(...action.payload.data.orders);
        } else {
          temp = action.payload.data;
        }
      } else {
        temp = action.payload.data;
      }
      state.orders = temp;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getOrders.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};

export const builderGetOrder = (builder: any) => {
  builder
    .addCase(getOrder.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getOrder.fulfilled, (state: any, action: any) => {
      state.order = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getOrder.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};

export const builderGetOrdersReportNew = (builder: any) => {
  builder
    .addCase(getOrdersReportNew.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getOrdersReportNew.fulfilled, (state: any, action: any) => {
      state.orderReports = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getOrdersReportNew.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};

export const builderGetOrdersReportTrip = (builder: any) => {
  builder
    .addCase(getOrdersReportTrip.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getOrdersReportTrip.fulfilled, (state: any, action: any) => {
      state.ordersReportTrip = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getOrdersReportTrip.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};

export const builderGetOrdersReportTripTracking = (builder: any) => {
  builder
    .addCase(getOrdersReportTripTracking.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getOrdersReportTripTracking.fulfilled, (state: any, action: any) => {
      state.ordersReportTripTracking = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getOrdersReportTripTracking.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
